import { supabase } from '../supabase';
import { TaskOffer } from '../types/taskOffer';
import { Tasker } from '../utils/types';

export const fetchTaskOfferWithStatus = async (
  taskId: number,
  status: string
): Promise<TaskOffer | null> => {
  const { data, error } = await supabase
    .from('task_offers')
    .select('*')
    .eq('task_id', taskId)
    .eq('status', status)
    .single();

  if (error) {
    console.error('Error fetching task offer:', error);
    return null;
  }

  return data;
};

//  | 'pending' | 'assigned' other states that dont apply here
export const createTaskOffer = async (
  taskId: number,
  taskerId: string,
  status: 'applied' | 'rejected'
): Promise<void> => {
  try {
    const { error } = await supabase.from('task_offers').insert({
      task_id: taskId,
      tasker_id: taskerId,
      status: status,
    });

    if (error) throw error;
  } catch (error) {
    console.error('Error creating task offer:', error);
    throw error;
  }
};

export const fetchTaskOfferForTasker = async (
  taskId: number,
  taskerId: number
): Promise<TaskOffer | null> => {
  try {
    const { data, error } = await supabase
      .from('task_offers')
      .select(
        `
        *,
        task:tasks(*)
      `
      )
      .eq('task_id', taskId)
      .eq('tasker_id', taskerId)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        // No matching row found, return null instead of throwing an error
        return null;
      }
      throw error;
    }
    return data;
  } catch (error) {
    console.error('Error fetching task offer:', error);
    throw error;
  }
};

export const fetchTaskOffersByTaskId = async (
  taskId: number
): Promise<(TaskOffer & { tasker: Tasker | null })[]> => {
  try {
    // Fetch task offers
    const { data: offers, error: offersError } = await supabase
      .from('task_offers')
      .select('*')
      .eq('task_id', taskId)
      .eq('status', 'assigned');

    if (offersError) throw offersError;

    if (!offers || offers.length === 0) return [];

    // Fetch tasker information for each offer
    const offersWithTaskers = await Promise.all(
      offers.map(async (offer) => {
        const { data: tasker, error: taskerError } = await supabase
          .from('taskers') // Assuming the table is called 'taskers'
          .select('id, name, last_name')
          .eq('id', offer.tasker_id)
          .single();

        if (taskerError) {
          console.error('Error fetching tasker:', taskerError);
          return { ...offer, tasker: null };
        }

        return { ...offer, tasker };
      })
    );

    return offersWithTaskers;
  } catch (error) {
    console.error('Error fetching task offers:', error);
    throw error;
  }
};

export const fetchOneTaskOffers = (taskId: number) => {

  return supabase
  .from('task_offers')
  .select(
    `
    *,
    tasker:tasker_id (
      id,
      name,
      last_name,
      email,
      phone_number,
      university,
      career,
      carreer,
      university_year,
      auth_id
    )
  `
  )
  .eq('task_id', taskId);
}

export const updateTaskOffer = (taskId: number, taskerId: number) => {
  return supabase
  .from('task_offers')
  .update({ proposal_sent: true })
  .eq('task_id', taskId)
  .eq('tasker_id', taskerId);
}

export const getTaskOfferById = (taskOfferId: number, paid: boolean) => {
  return supabase.from('task_offers').update({ paid }).eq('id', taskOfferId);

}